<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {},
}
</script>

<style scoped>
#app{
  width: 98.8vw;
  margin: 0px auto;
}
</style>
